import React from "react";
const MDM = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.125 5.75a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75ZM7.875 7.125a1.375 1.375 0 1 1 2.75 0 1.375 1.375 0 0 1-2.75 0Z"
      fill="#80B8EE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 6.438A3.438 3.438 0 0 0 19.562 3H4.438A3.438 3.438 0 0 0 1 6.438v1.375a3.438 3.438 0 0 0 3.438 3.437h6.875v2.819a3.443 3.443 0 0 0-2.598 2.354.68.68 0 0 0-.153-.017H2.687v1.375H8.58a3.438 3.438 0 0 0 6.84 0h5.892v-1.375h-5.875a.68.68 0 0 0-.152.017 3.443 3.443 0 0 0-2.598-2.354V11.25h6.875A3.438 3.438 0 0 0 23 7.812V6.438Zm-3.438-2.063c1.14 0 2.063.924 2.063 2.063v1.375a2.062 2.062 0 0 1-2.063 2.062H4.438a2.063 2.063 0 0 1-2.062-2.063V6.438c0-1.138.924-2.062 2.063-2.062h15.125Zm-7.562 11a2.062 2.062 0 1 0-.001 4.124A2.062 2.062 0 0 0 12 15.375Z"
      fill="#80B8EE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.85 6.438A3.588 3.588 0 0 1 4.437 2.85h15.125a3.588 3.588 0 0 1 3.588 3.588v1.375a3.588 3.588 0 0 1-3.588 3.587h-6.725v2.548a3.594 3.594 0 0 1 2.552 2.31.871.871 0 0 1 .048-.002h6.025v1.675h-5.909a3.588 3.588 0 0 1-7.107 0H2.537v-1.675h6.025a.87.87 0 0 1 .049.002 3.594 3.594 0 0 1 2.551-2.31V11.4H4.438A3.588 3.588 0 0 1 .85 7.813V6.438ZM4.437 3.15A3.288 3.288 0 0 0 1.15 6.438v1.375A3.288 3.288 0 0 0 4.437 11.1h7.026v3.091l-.12.025a3.293 3.293 0 0 0-2.485 2.252l-.041.133-.136-.031a.53.53 0 0 0-.119-.014H2.837v1.075h5.878l.014.135a3.288 3.288 0 0 0 6.542 0l.013-.135h5.878v-1.075h-5.725a.53.53 0 0 0-.118.014l-.136.03-.041-.133a3.293 3.293 0 0 0-2.484-2.251l-.12-.025V11.1h7.024a3.288 3.288 0 0 0 3.288-3.288V6.438a3.288 3.288 0 0 0-3.288-3.288H4.438Zm0 1.375a1.913 1.913 0 0 0-1.912 1.913v1.375c0 1.055.857 1.912 1.912 1.912h15.125a1.913 1.913 0 0 0 1.913-1.912V6.438a1.913 1.913 0 0 0-1.913-1.913H4.438ZM2.225 6.438c0-1.222.991-2.213 2.212-2.213h15.125c1.223 0 2.213.991 2.213 2.213v1.375c0 1.221-.99 2.212-2.212 2.212H4.437a2.213 2.213 0 0 1-2.212-2.212V6.438Zm7.562 11a2.212 2.212 0 1 1 4.424-.002 2.212 2.212 0 0 1-4.424.002ZM12 15.524a1.912 1.912 0 1 0-.001 3.824A1.912 1.912 0 0 0 12 15.525Z"
      fill="#80B8EE"
    />
  </svg>
)

export default MDM